import { Link } from "react-router-dom";

const RequestItem = ({ request, onConfirm, onDelete, isAccepting, isDeleting }) => {
    const handleConfirmClick = (e) => {
        e.preventDefault(); 
        onConfirm(request.id);
    };

    const handleDeleteClick = (e) => {
        e.preventDefault();
        onDelete(request.id);
    };

    const avatarSrc = request.profilePic?.startsWith("http")
        ? request.profilePic
        : (request.profilePic || "/noAvatar.png");

    return (
        <Link
            to={`/profile/${request.id}`}
            style={{ textDecoration: "none", color: "inherit" }}
        >
            <div className="requestItem">
                <div className="userInfo">
                    <img 
                        src={avatarSrc} 
                        alt={request.name} 
                        className="avatar" 
                    />

                    <span className="username">
                        {request.name}
                    </span>
                </div>

                <div className="buttons">
                    <button
                        className="confirm"
                        onClick={handleConfirmClick}
                        disabled={isAccepting}
                    >
                        Confirm
                    </button>

                    <button
                        className="delete"
                        onClick={handleDeleteClick}
                        disabled={isDeleting}
                    >
                        Delete
                    </button>
                </div>
            </div>
        </Link>
    );
};

export default RequestItem;